const Travel = () => {
  return (
    <div>
      <div className="">
        <img src="/ExpressBanner/banner-6.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">

          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
              Travel and Tours
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              The travel and visa division provides specialised services in air ticketing for all
              domestic and international carriers, with complimentary insurance cover.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Intiana, the travel and visa division of TCS (Pvt.) Limited, commenced its operations
              in 2004. Intiana provides specialised services in air ticketing for all domestic and 
              international carriers, with complimentary insurance cover. Whether the nature of travel is business,
              pleasure or spiritual, the company offers exclusive, customised packages to its customers, to suit
              their budgeting needs.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Customers can personalise their Umrah experience and make their travel plans easy and convenient
              with special, all-inclusive packages, that also include various hotel accommodation options at extremely
              competitive rates. Customers can also avail our multiple worldwide destination tour packages, which include
              complimentary travel insurance. Intiana’s value-added services assist customers with visa processing, arrival
              and departure, and transportation to and from various airports.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
    </div>
  );
};

export default Travel;
